import { SearchFilterConditionDate } from 'lib-search-types';

import { SearchFilterConditionDateField } from 'app/views/layout/views/search/utils/filters/filterTypeGuards';

import { ConditionFieldProps } from '../../conditionField';

import { ConditionFieldDateRange } from './components/conditionFieldDateRange';
import { ConditionFieldDateSingle } from './components/conditionFieldDateSingle';

export type ConditionFieldDateProps = ConditionFieldProps<
  SearchFilterConditionDate<SearchFilterConditionDateField>
>;

/**
 * Represents a component that can be used to visualize a date or a date range
 * filter
 */
export const ConditionFieldDate = (
  props: ConditionFieldDateProps,
): JSX.Element => {
  const { condition } = props;
  const isRange = condition.operator === 'between';

  if (isRange) {
    return <ConditionFieldDateRange {...props} />;
  }
  return <ConditionFieldDateSingle {...props} />;
};
